// extracted by mini-css-extract-plugin
export default {"loadWrapper":"InfiniteLoader_loadWrapper__W8xmp","load":"InfiniteLoader_load__1dQey","activity":"InfiniteLoader_activity__TEXZv"};